/**
 * Maintenance report grid — filter→param builder.
 *
 * Turns the maintenance report's scope selection, "Show" single-select
 * (alarms / maintenance / both), and alarm-category multi-select into the
 * EntityGrid `extraParams` object for odl-app/maintenance-report/. Kept
 * feature-local so the endpoint's param names live next to the grid, while
 * scope/flag/merge mechanics compose from the shared queryParams kit.
 *
 * Contains:
 * - buildMaintenanceReportParams — filter state → extraParams
 */

import { buildQueryParams, withFlags, withScope } from '@sophocles/utils/queryParams';

/**
 * @param {Object} filters
 * @param {number} [filters.customerId]
 * @param {number} [filters.siteGroupId]
 * @param {'default'|'alarms'|'maintenance'|'alarmsAndMaintenance'} [filters.filterOption]
 * @param {Array<{ id: number }>} [filters.selectedCategories]
 * @returns {Object} EntityGrid extraParams
 */
export const buildMaintenanceReportParams = ({ customerId, siteGroupId, filterOption, selectedCategories = [] }) =>
  buildQueryParams(
    withScope({}, { customerId, siteGroupId }),
    withFlags(
      {},
      {
        has_alarms: filterOption === 'alarms' || filterOption === 'alarmsAndMaintenance',
        has_maintenance: filterOption === 'maintenance' || filterOption === 'alarmsAndMaintenance',
      },
    ),
    selectedCategories.length ? { alarm_category_ids: selectedCategories.map(c => c.id).join(',') } : {},
  );
